import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, query, onSnapshot, orderBy, addDoc, doc, deleteDoc, updateDoc, setDoc, getDoc } from './firestore-compat';
import './App.css'; // reaproveitar estilos

const GESTAO_AULAS_DESATIVADO = true;

function AdminTutoriais() {
  const [activeTab, setActiveTab] = useState('videos');

  // --- VÍDEOS ---
  const [videos, setVideos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ titulo: '', url: '', descricao: '', duracao: '', ativo: true, especialidadesVideo: [] });

  // --- RELATÓRIO ---
  const [visualizacoes, setVisualizacoes] = useState([]);
  const [filtroVideo, setFiltroVideo] = useState('');

  // --- CONFIGURAÇÕES ---
  const [especialidades, setEspecialidades] = useState([]);
  const [novaEspecialidade, setNovaEspecialidade] = useState('');
  const [cooperativas, setCooperativas] = useState([]);
  const [novaCooperativa, setNovaCooperativa] = useState('');

  // CARREGAR DADOS
  useEffect(() => {
    if (GESTAO_AULAS_DESATIVADO) return;
    const unsubVideos = onSnapshot(query(collection(db, 'tutoriais'), orderBy('criadoEm', 'desc')), snap => {
      setVideos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    const unsubVis = onSnapshot(query(collection(db, 'tutoriais_visualizacoes'), orderBy('dataVisualizacao', 'desc')), snap => {
      setVisualizacoes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    const loadConfig = async () => {
      const docRef = doc(db, 'configuracoes', 'tutoriais');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setEspecialidades(data.especialidades || []);
        setCooperativas(data.cooperativas || []);
      } else {
        // Inicializa se não existir
        await setDoc(docRef, { especialidades: [], cooperativas: [] });
      }
    };
    loadConfig();

    return () => { unsubVideos(); unsubVis(); };
  }, []);

  // --- FUNÇÕES DE VÍDEOS ---
  const handleSaveVideo = async (e) => {
    e.preventDefault();
    if (editId) {
      await updateDoc(doc(db, 'tutoriais', editId), { ...form });
    } else {
      await addDoc(collection(db, 'tutoriais'), { ...form, criadoEm: new Date() });
    }
    setShowModal(false);
  };

  const handleDeleteVideo = async (id) => {
    if (window.confirm("Deseja realmente excluir este tutorial?")) {
      await deleteDoc(doc(db, 'tutoriais', id));
    }
  };

  const openNewVideo = () => {
    setEditId(null);
    setForm({ titulo: '', url: '', descricao: '', duracao: '', ativo: true, especialidadesVideo: [] });
    setShowModal(true);
  };

  const openEditVideo = (video) => {
    setEditId(video.id);
    setForm({ 
      titulo: video.titulo, 
      url: video.url, 
      descricao: video.descricao || '', 
      duracao: video.duracao || '', 
      ativo: video.ativo,
      especialidadesVideo: video.especialidadesVideo || []
    });
    setShowModal(true);
  };

  // --- FUNÇÕES DE CONFIGURAÇÃO ---
  const updateConfigDoc = async (novasEspecialidades, novasCooperativas) => {
    const docRef = doc(db, 'configuracoes', 'tutoriais');
    await setDoc(docRef, { especialidades: novasEspecialidades, cooperativas: novasCooperativas }, { merge: true });
  };

  const addEspecialidade = async () => {
    if (!novaEspecialidade.trim()) return;
    const lista = [...especialidades, novaEspecialidade.trim()];
    setEspecialidades(lista);
    await updateConfigDoc(lista, cooperativas);
    setNovaEspecialidade('');
  };

  const removeEspecialidade = async (index) => {
    const lista = [...especialidades];
    lista.splice(index, 1);
    setEspecialidades(lista);
    await updateConfigDoc(lista, cooperativas);
  };

  const addCooperativa = async () => {
    if (!novaCooperativa.trim()) return;
    const lista = [...cooperativas, novaCooperativa.trim()];
    setCooperativas(lista);
    await updateConfigDoc(especialidades, lista);
    setNovaCooperativa('');
  };

  const removeCooperativa = async (index) => {
    const lista = [...cooperativas];
    lista.splice(index, 1);
    setCooperativas(lista);
    await updateConfigDoc(especialidades, lista);
  };


  // ESTILOS
  const inputStyle = { padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '100%', marginBottom: '10px' };
  const btnStyle = { padding: '8px 16px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' };
  const btnDangerStyle = { ...btnStyle, background: '#dc3545' };

  if (GESTAO_AULAS_DESATIVADO) {
    return (
      <div style={{ padding: '80px 20px', textAlign: 'center' }}>
        <div style={{ fontSize: 54, marginBottom: 16 }}>🛠️</div>
        <h3 style={{ color: '#1e293b', marginBottom: 8, fontWeight: 700, fontSize: '1.2rem' }}>Gestão de Aulas desativada</h3>
        <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Este módulo não está mais em uso.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '20px' }}>Gestão de Aulas / Tutoriais</h2>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #ddd', paddingBottom: '10px' }}>
        <button style={{ ...btnStyle, background: activeTab === 'videos' ? '#0056b3' : '#6c757d' }} onClick={() => setActiveTab('videos')}>Vídeos</button>
        <button style={{ ...btnStyle, background: activeTab === 'relatorio' ? '#0056b3' : '#6c757d' }} onClick={() => setActiveTab('relatorio')}>Relatório de Visualizações</button>
        <button style={{ ...btnStyle, background: activeTab === 'config' ? '#0056b3' : '#6c757d' }} onClick={() => setActiveTab('config')}>Configurações (Listas)</button>
      </div>

      {/* --- ABA DE VÍDEOS --- */}
      {activeTab === 'videos' && (
        <div>
          <button style={{ ...btnStyle, marginBottom: '20px' }} onClick={openNewVideo}>+ Novo Tutorial</button>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
            {videos.map(v => (
              <div key={v.id} style={{ border: '1px solid #eee', borderRadius: '8px', padding: '15px', background: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                <h4 style={{ margin: '0 0 10px' }}>{v.titulo}</h4>
                <p style={{ fontSize: '14px', color: '#666', margin: '0 0 10px' }}>{v.duracao} - {v.ativo ? 'Ativo' : 'Inativo'}</p>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button style={{ ...btnStyle, background: '#28a745', padding: '5px 10px', fontSize: '13px' }} onClick={() => openEditVideo(v)}>Editar</button>
                  <button style={{ ...btnDangerStyle, padding: '5px 10px', fontSize: '13px' }} onClick={() => handleDeleteVideo(v.id)}>Excluir</button>
                </div>
              </div>
            ))}
          </div>

          {/* Modal de Vídeo */}
          {showModal && (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
              <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', width: '500px', maxWidth: '90%' }}>
                <h3 style={{ marginTop: 0 }}>{editId ? 'Editar Tutorial' : 'Novo Tutorial'}</h3>
                <form onSubmit={handleSaveVideo}>
                  <label>Título:</label>
                  <input style={inputStyle} value={form.titulo} onChange={e => setForm({...form, titulo: e.target.value})} required />
                  
                  <label>URL do Vídeo (Link do Drive ou YouTube):</label>
                  <input style={inputStyle} value={form.url} onChange={e => setForm({...form, url: e.target.value})} required />
                  <small style={{display:'block', marginBottom:'10px', color:'#777'}}>Se for Google Drive, coloque o link compartilhado. O sistema tentará embutir automaticamente.</small>
                  
                  <label>Duração (ex: 15 min):</label>
                  <input style={inputStyle} value={form.duracao} onChange={e => setForm({...form, duracao: e.target.value})} />
                  
                  <label>Vincular às Especialidades:</label>
                  <div style={{ marginBottom: '15px', maxHeight: '100px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', borderRadius: '4px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                      <input 
                        type="checkbox" 
                        checked={form.especialidadesVideo.length === 0} 
                        onChange={() => setForm({...form, especialidadesVideo: []})} 
                      />
                      Todas as Especialidades (Público Geral)
                    </label>
                    {especialidades.map((esp, i) => (
                      <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px', marginLeft: '20px' }}>
                        <input 
                          type="checkbox" 
                          checked={form.especialidadesVideo.includes(esp)} 
                          onChange={(e) => {
                            if (e.target.checked) {
                              setForm({...form, especialidadesVideo: [...form.especialidadesVideo, esp]});
                            } else {
                              setForm({...form, especialidadesVideo: form.especialidadesVideo.filter(item => item !== esp)});
                            }
                          }} 
                        />
                        {esp}
                      </label>
                    ))}
                  </div>

                  <label>Descrição Opcional:</label>
                  <textarea style={{...inputStyle, height: '80px'}} value={form.descricao} onChange={e => setForm({...form, descricao: e.target.value})} />
                  
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
                    <input type="checkbox" checked={form.ativo} onChange={e => setForm({...form, ativo: e.target.checked})} />
                    Vídeo Ativo (Visível para o público)
                  </label>

                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      {editId && (
                        <button type="button" style={{ ...btnDangerStyle }} onClick={() => { handleDeleteVideo(editId); setShowModal(false); }}>Excluir Vídeo</button>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button type="button" style={{ ...btnStyle, background: '#6c757d' }} onClick={() => setShowModal(false)}>Cancelar</button>
                      <button type="submit" style={btnStyle}>Salvar</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      )}

      {/* --- ABA DE RELATÓRIO --- */}
      {activeTab === 'relatorio' && (
        <div>
          <div style={{ marginBottom: '20px' }}>
            <label>Filtrar por Vídeo: </label>
            <select style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} value={filtroVideo} onChange={e => setFiltroVideo(e.target.value)}>
              <option value="">Todos os vídeos</option>
              {videos.map(v => <option key={v.id} value={v.id}>{v.titulo}</option>)}
            </select>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
            <thead>
              <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '10px', textAlign: 'left' }}>Data</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Nome</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Especialidade</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Cooperativa</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Contato (Whats/Email)</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Vídeo Assistido</th>
              </tr>
            </thead>
            <tbody>
              {visualizacoes
                .filter(v => filtroVideo === '' || v.tutorialId === filtroVideo)
                .map(vis => (
                <tr key={vis.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px' }}>{vis.dataVisualizacao ? new Date(vis.dataVisualizacao.seconds * 1000).toLocaleString() : ''}</td>
                  <td style={{ padding: '10px' }}>{vis.nomeUsuario}</td>
                  <td style={{ padding: '10px' }}>{vis.especialidade}</td>
                  <td style={{ padding: '10px' }}>{vis.cooperativa ? `Sim (${vis.qualCooperativa || '-'})` : 'Não'}</td>
                  <td style={{ padding: '10px' }}>
                    <div>{vis.telefone}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{vis.email}</div>
                  </td>
                  <td style={{ padding: '10px' }}>{vis.tutorialTitulo}</td>
                </tr>
              ))}
              {visualizacoes.length === 0 && (
                <tr><td colSpan="6" style={{ padding: '20px', textAlign: 'center', color: '#888' }}>Nenhuma visualização registrada.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* --- ABA DE CONFIGURAÇÕES --- */}
      {activeTab === 'config' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' }}>
          
          {/* Especialidades */}
          <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #eee' }}>
            <h3>Especialidades Disponíveis</h3>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
              <input style={inputStyle} placeholder="Nova especialidade" value={novaEspecialidade} onChange={e => setNovaEspecialidade(e.target.value)} />
              <button style={{ ...btnStyle, height: '35px', marginTop: '2px' }} onClick={addEspecialidade}>Adicionar</button>
            </div>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {especialidades.map((esp, i) => (
                <li key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', borderBottom: '1px solid #eee' }}>
                  {esp}
                  <button style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }} onClick={() => removeEspecialidade(i)}>Excluir</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Cooperativas */}
          <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #eee' }}>
            <h3>Cooperativas Disponíveis</h3>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
              <input style={inputStyle} placeholder="Nova cooperativa" value={novaCooperativa} onChange={e => setNovaCooperativa(e.target.value)} />
              <button style={{ ...btnStyle, height: '35px', marginTop: '2px' }} onClick={addCooperativa}>Adicionar</button>
            </div>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {cooperativas.map((coop, i) => (
                <li key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', borderBottom: '1px solid #eee' }}>
                  {coop}
                  <button style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }} onClick={() => removeCooperativa(i)}>Excluir</button>
                </li>
              ))}
            </ul>
          </div>

        </div>
      )}

    </div>
  );
}

export default AdminTutoriais;
